<div class="empty-state">
    <div class="empty-icon">
        <hugeicons-icon [icon]="icon" [size]="iconSize"></hugeicons-icon>
    </div>
    <div class="empty-title">{{ title }}</div>
    <div class="empty-description">{{ description }}</div>
</div>
